import { html } from "lit-element";
import { StofwareElement } from "@stofloos/core/base/sw-element/index";
import { initDialog, openDialog, closeDialog } from "@stofloos/actions/dialog";
import dialog from "@stofloos/reducers/dialog";
import { store } from "@stofloos/stores/store";
import { connect } from "pwa-helpers";

import { icon } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import { style } from "./style";

import { StofwareColors } from "@stofloos/globals/styles/colors";
import { StofwareText } from "@stofloos/globals/styles/typography";
import { LayoutFlex } from "@stofloos/globals/styles/layout-flex";
import { ButtonOutlinedStyle } from "@stofloos/components/atoms/buttons/button-outlined";
import Popper from "popper.js";
import {findParentBySelector, closestElement} from "@stofloos/utils/sw-constants";
import {KeyEventAction} from "@stofloos/utils/sw-events";

store.addReducers({
	dialog
});

class DialogSimple extends connect(store)(StofwareElement) {
	static get styles() {
		return [style, LayoutFlex, ButtonOutlinedStyle, StofwareText, StofwareColors];
	}
	static get properties() {
		return {
			dialogId: String,
			active: Boolean,
			relative: {type:Boolean},
			popper: {type: Object},
			keyEvent: {type: Object}
		};
	}

	constructor() {
		super();
	}

	render() {
		// language=HTML
		return html`
			${this.active
				? html`
						<div class="modal" ?relative="${this.relative}">
							<div class="modal-container">
								<div class="modal-background" @click="${() => this.close()}"></div>
								<div class="modal-content">
									<span class="close" @click="${() => this.close()}">${icon(faTimes).node}</span>
									<slot></slot>
								</div>
							</div>
						</div>
				  `
				: html``}
		`;
	}

	firstUpdated() {
		if (this.dialogId === undefined) {
			console.error("No dialogId property");
		}
		store.dispatch(initDialog(this.dialogId, false));
	}

	updated(changedProperties) {
		if(this.active && changedProperties.has('active')){
			this.keyEvent = new KeyEventAction('Escape', () => this.close());
		} else if (changedProperties.has('active') && this.keyEvent) {
			this.keyEvent.removeKeyAction();
		}

		if(this.relative && this.active && changedProperties.has('active')) {
			const container = closestElement('.dialog-simple-bondaries', this);
			if(container){
				this.popper = new Popper(this.shadowRoot.querySelector('.modal'), this.shadowRoot.querySelector('.modal-content'), {
					placement: 'right',
					modifiers: {
						flip: {
							behavior: ['left', 'right', 'top']
						},
						preventOverflow: {
							boundariesElement: container,
						},
					},
				});
			}
		}
	}

	stateChanged(state) {
		if (state.dialog && state.dialog[this.dialogId]) {
			this.active = state.dialog[this.dialogId].active;
		}
	}

	close() {
		store.dispatch(closeDialog(this.dialogId));
	}

	open() {
		store.dispatch(openDialog(this.dialogId));
	}
}

window.customElements.define("dialog-simple", DialogSimple);
